import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Card, CardContent, Icon } from '@mui/material';
import MedicationIcon from '@mui/icons-material/Medication';
import { CheckCircle, HighlightOff } from '@mui/icons-material';

const refillData = [
  { id: 1, message: 'Refill your prescription for Medication A.', status: 'pending' },
  { id: 2, message: 'Refill your prescription for Medication B.', status: 'completed' }
];

const RefillPage = () => {
  return (
    <Box sx={{ backgroundColor: '#121212', color: 'white', p: 4, pt: { xs: '4rem', sm: '4.5rem', md: '5rem' } }}>
      <Typography variant='h3' sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>Refills</Typography>
      <List>
        {refillData.map((refill) => (
          <ListItem key={refill.id} sx={{ mb: 2 }}>
            <Card sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#1f1f1f', borderRadius: '8px', boxShadow: 3 }}>
              <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                <MedicationIcon sx={{ fontSize: '40px', color: '#FFD700', mr: 2 }} />
                <ListItemText primary={refill.message} />
              </CardContent>
              <Box sx={{ pr: 2 }}>
                {refill.status === 'completed'
                  ? (
                    <CheckCircle sx={{ color: '#4CAF50' }} />
                    )
                  : (
                    <HighlightOff sx={{ color: '#F44336' }} />
                    )}
              </Box>
            </Card>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default RefillPage;
